import { Slider } from '@mui/material';
import PropTypes from 'prop-types';

const marks = (() => {
  const marks = [];
  for (let value = 5000; value <= 50000; value += 5000) {
    marks.push({
      value,
      label: `${value / 1000}k`,
    });
  }
  return marks;
})();

const ContactsNumberSlider = ({ value, onChange, disabled }) => {
  return (
    <div>
      <div className="flex items-center justify-between text-base">
        <div>Number of Contacts:</div>
        <div className="font-semibold">Up to {value.toLocaleString()}</div>
      </div>
      <Slider
        aria-label="Number of contacts"
        value={value}
        step={null}
        min={3000}
        max={52000}
        marks={marks}
        className="!h-2"
        onChange={(_, newValue) => onChange(newValue)}
        disabled={disabled}
        slotProps={{
          rail: {
            className: '!bg-gray-200',
          },
          mark: {
            className: '!size-1 !rounded-sm !bg-white-100',
          },
          markLabel: {
            className: '!text-sm !text-gray-500',
          },
          thumb: {
            className: '!bg-white-100 !border-4 !border-primary-700 !size-4',
          },
        }}
      />
    </div>
  );
};

ContactsNumberSlider.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ContactsNumberSlider.defaultProps = {
  disabled: false,
};

export default ContactsNumberSlider;
